var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated fadeIn",attrs:{"id":"iframediv"}},[_c('iframe',{staticStyle:{"border-width":"0px"},attrs:{"width":"100%","height":"100%","src":_vm.src}})])
}
var staticRenderFns = []

export { render, staticRenderFns }